import DemoTop from "page/DemoTop.vue";
import DemoLogin from "page/DemoLogin.vue";
import DemoSignup from "page/DemoSignup.vue";
import Verify from "page/Verify.vue";
import Logout from "page/Logout.vue";
import PasswordRemindFrom from "page/PasswordRemindFrom.vue";
import PasswordRemindRequest from "page/PasswordRemindRequest.vue";
import PasswordRemindVerify from "page/PasswordRemindVerify.vue";
import PasswordRemindComplete from "page/PasswordRemindComplete.vue";

import MyPage from "page/MyPage.vue";
import Unsupported from "page/Unsupported.vue";

import MyPage_Event from "page/subPages/MyPage/Event.vue";
import MyPage_Event_Organization from "page/subPages/MyPage/Event/Organization.vue";
import MyPage_Event_Viewing from "page/subPages/MyPage/Event/Viewing.vue";

import MyPage_ChildInfo from "page/subPages/MyPage/ChildInfo.vue";
import MyPage_OrdererInfo from "page/subPages/MyPage/OrdererInfo.vue";

import MyPage_Order from "page/subPages/MyPage/Order.vue";
import MyPage_Order_History from "page/subPages/MyPage/Order/History.vue";
import MyPage_Order_Download from "page/subPages/MyPage/Order/Download.vue";

import Order_Catalog from "page/subPages/Order/Catalog.vue";
import Order_Cart from "page/subPages/Order/Cart.vue";
import Order_Form from "page/subPages/Order/Form.vue";

import Order_Confirm from "page/subPages/Order/Confirm.vue";
import Order_DemoQuestionnaire from "page/subPages/Order/DemoQuestionnaire.vue";
import Order_DemoQuestionnaireOrderer from "page/subPages/Order/DemoQuestionnaireOrderer.vue";

import Payment from "page/Payment.vue";
import Payment_Form from "page/subPages/Payment/Form.vue";
import Payment_Complate from "page/subPages/Payment/Complete.vue";

export default {
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: "/", redirect: {name:'top'},
    },

    /* デモトップページ */
    {
      path: "/top", component: DemoTop,name: 'top',
      meta:{
        isLoggedInPage:false
      },
    },
    {
      path: "/top/:lang_code", name: 'top_with_lang_code', redirect: to => {
        return { name: 'top', query: {"lang":to.params.lang_code} }
      },
    },
    /* デモアカウント登録 */
    {
      path: "/signup", component: DemoSignup, name: 'demo-signup',
      meta:{
        isLoggedInPage:false
      },
    },
    ////新規登録
    /* デモログイン登録 */
    {
      path: "/signin", component: DemoLogin, name: 'demo-login',
      meta:{
        isLoggedInPage:false
      },
    },
    /* 確認コード入力 */
    {
      path: "/verify", component: Verify, name: 'verify',
      meta:{
        isLoggedInPage:false
      },
    },
    /* 確認コード入力 */
    {
      path: "/logout", component: Logout, name: 'logout',
      meta:{
        isLoggedInPage:false
      },
    },
    //// パスワード再設定
    /* パスワードリセット */
    {
      path: "/remind/form", component: PasswordRemindFrom, name: 'password-remind-from',
      meta:{
        isLoggedInPage:false
      },
    },
    {
      path: "/remind/request", component: PasswordRemindRequest, name: 'password-remind-request',
      meta:{
        isLoggedInPage:false
      },
    },
    {
      path: "/remind/verify", component: PasswordRemindVerify, name: 'password-remind-verify',
      meta:{
        isLoggedInPage:false
      },
    },
    {
      path: "/remind/complete", component: PasswordRemindComplete, name: 'password-remind-complete',
      meta:{
        isLoggedInPage:false
      },
    },

    ////マイページ
    {
      /* マイページ */
      path: "/mypage", component: MyPage, name: 'mypage',redirect: {name:'mypage::event'},
      meta:{
        isLoggedInPage:true
      },
      children: [
        {
          name: 'mypage::event', path: 'event', component: MyPage_Event,redirect: {name:'mypage::event::viewing'},
          children: [
            {
              name: 'mypage::event::viewing', path: 'viewing', component: MyPage_Event_Viewing,
            },
            {
              name: 'mypage::event::organization', path: 'organization/:organization_school_code_id', component: MyPage_Event_Organization,
            },
            {
              name: 'mypage::event::catalog', path: 'catalog/:event_id', component: Order_Catalog,
            },
            {
              name: 'mypage::event::cart', path: 'cart', component: Order_Cart,
            },
            {
              name: 'mypage::event::order_form', path: 'order_form', component: Order_Form,
            },
            {
              name: 'mypage::event::order_confirm', path: 'order_confirm', component: Order_Confirm,
            },
            {
              name: 'mypage::event::demo_questionnaire', path: 'demo_questionnaire', component: Order_DemoQuestionnaire,
            },
            {
              name: 'mypage::event::demo_questionnaire_orderer', path: 'demo_questionnaire_orderer', component: Order_DemoQuestionnaireOrderer,
            },
          ],
        },
        {
          name: 'mypage::child_info', path: 'child_info', component: MyPage_ChildInfo,
        },
        {
          name: 'mypage::child_info::detail', path: 'child_info/:child_info_id', component: MyPage_ChildInfo,
        },
        {
          name: 'mypage::orderer_info', path: 'orderer_info', component: MyPage_OrdererInfo,
        },
       {
        /* マイページ */
        path: "order",  component: MyPage_Order,name: 'mypage::order',redirect: {name:'mypage::order::history'},
          children: [
            {
              name: 'mypage::order::history', path: 'history', component: MyPage_Order_History,
            },
            {
              name: 'mypage::order::download', path: 'download/:order_id', component: MyPage_Order_Download,
            }
          ]
        }
      ]
    },
    {
      /* 決済 */
      path: "/payment", component: Payment, name: 'payment',redirect: {name:'payment::form'},
      meta:{
        isLoggedInPage:true
      },
      children: [
        {
          name: 'payment::form', path: 'form', component: Payment_Form,
        },
        {
          name: 'payment::complete', path: 'complate', component: Payment_Complate,
        },
      ]
    },

    // {
    //   path: "/payment_complete", component: Payment_Complete, name: 'payment::complete',
    //   meta:{
    //     isLoggedInPage:true
    //   },
    // },
    {
      /* ブラウザ非対応ページ(アプリでは使用せずに静的化して利用) */
      path: "/unsupported", component: Unsupported, name: 'unsupported',
      meta:{
        isLoggedInPage:false
      },
    },
    // { path: '*', redirect: '/' }
    /* デモトップページ言語設定のリダイレクト */
    {
      path: "/:lang_code", redirect: to => {
        return {name: 'top', query: {"lang": to.params.lang_code}}
      }
    },
  ]
}



// WEBPACK FOOTER //
// ./src/systems/routes.js